import "./AccommodationSection.scss";

const accommodations = [
  {
    title: "Búzál-Mórocza pincészet",
    description:
      "Távolabb a helyszínünktől, de a biztosított transzferrel könnyen megközelíthető.",
    link: "https://www.facebook.com/buzalmorocza",
    image: "/images/buzal-venue.jpg",
  },
  {
    title: "Kácsor fogadó",
    description:
      "Olcsóbb kategóriájú szállás, megközelítés szintén transzferrel.",
    link: "http://www.kacsorfogado.hu/",
    image: "/images/kacsor-venue.jpg",
  },
  {
    title: "Átrium panzió",
    description:
      "A helyszín utcájában, transzfer nem szükséges, gyalog is megközelíthető.",
    link: "https://www.facebook.com/atriumpanzioborhaz/?locale=hu_HU",
    image: "/images/atrium-venue.jpg",
  },
];

export const AccommodationSection = () => {
  return (
    <section id="accommodation" className="accommodation-section">
      <div className="accommodation-content">
      <div className="accommodation-header">
        <h2>Szállások</h2>

        <p className="accommodation-intro">
          Ajánlunk pár elérhető szállás opciót, de bátran nézelődjetek
          magatoknak is. Ha távolabbi szálláslehetőséget tudtok csak
          foglalni Etyeken belül, nem kell aggódni, 01:15-től transzfer
          szolgáltatást biztosítunk Nektek, amivel megkönnyítjük a
          hazautat a szállásig.

          <br />
          <br />

          A szállásfoglalást viszont egyénileg, saját preferenciák és
          igények szerint szükséges intézni.
        </p>
      </div>

        <div className="accommodation-list">
          {accommodations.map((item, index) => (
            <div
              key={item.title}
              className={`accommodation-item ${
                index % 2 !== 0 ? "reverse" : ""
              }`}
            >
              <div className="accommodation-image">
                <img
                  src={item.image}
                  alt={item.title}
                />
              </div>

              <div className="accommodation-text">
                <h3>{item.title}</h3>

                <p>{item.description}</p>

                <a
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  Weboldal megtekintése →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};